// extracted by mini-css-extract-plugin
export var container = "styles-module--container--28971";
export var customGif = "styles-module--custom-gif--87fb9";
export var links = "styles-module--links--54fbc";